import CONSTANTS from '../constants';
import LoginService from './LoginService';

export default {
  getNotifications,
  seeNotifications,
  openNotifications
};

async function getNotifications() {
  if (LoginService.getToken()) {
    const { token } = LoginService.getToken();
    let response = await fetch(`${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.NOTIFICATIONS.DEFAULT}`, {
      method: 'GET',
      headers: { ...CONSTANTS.REQUEST_HEADERS, 'X-ACCESS-TOKEN': token }
    });
    response = await response.json();
    if (response) return response;
    throw new Error('Could not get notifications');
  }
}

async function seeNotifications(notificationIds) {
  let postData = {
    notification_ids: notificationIds,
    status_type: 'status',
    status_value: CONSTANTS.NOTIFICATIONS.VARIABLES.SEEN_STATUS.SEEN
  };

  return bulkUpdate(postData);
}

function openNotifications(notificationIds) {
  let postData = {
    notification_ids: notificationIds,
    status_type: 'opened_status',
    status_value: CONSTANTS.NOTIFICATIONS.VARIABLES.OPENED_STATUS.OPENED
  };

  return bulkUpdate(postData);
}

async function bulkUpdate(postData) {
  const { token } = LoginService.getToken();

  let response = await fetch(
    `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.NOTIFICATIONS.DEFAULT}/bulkUpdate`,
    {
      body: JSON.stringify(postData),
      method: 'PATCH',
      headers: { ...CONSTANTS.REQUEST_HEADERS, 'X-ACCESS-TOKEN': token }
    }
  );

  response = await response.json();
  if (response) return response;
  throw new Error('Could not update notifications');
}
